var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup27660(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.364 16H3v-.714c0-1.332.87-2.45 2.045-2.767M6.41 10.164c-.794-.294-1.363-1.088-1.363-2.021 0-.933.57-1.727 1.364-2.02M16.635 16h1.364v-.714c0-1.332-.87-2.45-2.046-2.767M14.594 6.122c.794.294 1.363 1.088 1.363 2.021 0 .933-.569 1.727-1.363 2.02M11.86 12.429H9.135c-1.507 0-2.728 1.279-2.728 2.857V16h8.182v-.714c0-1.578-1.221-2.857-2.727-2.857zM10.499 10.286c1.13 0 2.045-.96 2.045-2.143 0-1.184-.916-2.143-2.045-2.143-1.13 0-2.046.96-2.046 2.143 0 1.183.916 2.143 2.046 2.143z",
    stroke: "#7E7E7E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup27660);
export default __webpack_public_path__ + "static/media/Group 27660.b2752ae65dfe717088dbd3f0ac82381b.svg";
export { ForwardRef as ReactComponent };